import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

/** Challenge door: a small task and a self-reported «Done» tick. */
@observer
class AdventChallengeDoor extends Component {
    constructor(props) {
        super(props);
        this.state = { busy: false };
    }

    done = async () => {
        const { adventCalendarStore } = this.props.stores;
        const { day } = this.props;
        this.setState({ busy: true });
        await adventCalendarStore.completeChallenge(day);
        this.setState({ busy: false });
    }

    render() {
        const { door = {} } = this.props;
        const { busy } = this.state;
        const text = door.content?.challenge || '';
        return (
            <div class='text-center'>
                <div style='font-size: 3rem;'>💪</div>
                <div class='fs-5 fw-bold mb-3'>{text}</div>
                {door.challengeDone ? (
                    <div class='alert alert-success'>
                        <i class='fa-solid fa-check me-2' />
                        <Text id='adventCalendar.challengeDone'>Done! Nice work.</Text>
                    </div>
                ) : (
                    <button type='button' class='btn btn-success btn-lg' disabled={busy} onClick={this.done}>
                        <i class='fa-solid fa-check me-2' /><Text id='adventCalendar.markDone'>Done ✓</Text>
                    </button>
                )}
            </div>
        );
    }
}

export default AdventChallengeDoor;
